// src/hooks/useScript.ts
import { useState, useEffect } from "react";

export const useScript = (src: string) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    // Check if script already exists
    const existingScript = document.querySelector(`script[src="${src}"]`);

    if (existingScript) {
      setLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;

    script.onload = () => {
      setLoaded(true);
    };

    script.onerror = () => {
      setError(true);
      console.error(`Failed to load script: ${src}`);
    };

    document.body.appendChild(script);

    return () => {
      // Don't remove the script on unmount - it's needed globally
    };
  }, [src]);

  return { loaded, error };
};
